import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import LoginForm from "./LoginForm";
import { MFASetup, MFA_CTX_LOGIN } from "@limitless/portal";
import { useExpertProfileContext, useLoginWrapperContext } from "../../../../expert";
const LoginWrapper = ({
  isManagerPortal
}) => {
  const {
    mfaLoginState,
    mfaVerifyScreenSuccessCB
  } = useLoginWrapperContext();
  const {
    profile
  } = useExpertProfileContext();
  return /*#__PURE__*/React.createElement(React.Fragment, null, mfaLoginState.isMfaChallenged ? /*#__PURE__*/React.createElement(MFASetup, {
    mfaCtx: MFA_CTX_LOGIN,
    screen: "mfaVerify",
    profile: profile,
    verifySuccessCB: mfaVerifyScreenSuccessCB
  }) : /*#__PURE__*/React.createElement(LoginForm, {
    isManagerPortal: isManagerPortal
  }));
};
export default LoginWrapper;
LoginWrapper.propTypes = {
  isManagerPortal: PropTypes.bool
};